const theme = {
    light: {
      primary: '#167378',         // Main theme color (used for buttons, icons, etc.)
      primaryDark: '#125e60',     // Darker shade for hover effects
      secondary: '#dc3545',       // Secondary color (used for logout, errors)
      secondaryLight: '#f8e6e8',  // Light secondary for hover effects
      background: '#f8f9fa',      // Main background color
      cardBackground: '#ffffff',  // Background for cards/sections
      cardHover: '#e9ecef',       // Hover background for cards
      textPrimary: '#333333',     // Primary text color
      textSecondary: '#555555',   // Secondary text color
      border: '#e9ecef',          // Border color
      shadow: 'rgba(0, 0, 0, 0.1)', // Shadow color
    },
    dark: {
      primary: '#1a8c92',         // Adjusted for better contrast in dark mode
      primaryDark: '#167378',     // Darker shade for hover effects
      secondary: '#ff4d4f',       // Adjusted secondary color for dark mode
      secondaryLight: '#661010',  // Darker secondary for hover effects
      background: '#1e1e1e',      // Dark background
      cardBackground: '#2c2c2c',  // Darker cards/sections
      cardHover: '#383838',       // Hover background for cards
      textPrimary: '#e0e0e0',     // Light text for contrast
      textSecondary: '#b0b0b0',   // Lighter secondary text
      border: '#444444',          // Darker border
      shadow: 'rgba(0, 0, 0, 0.3)', // Darker shadow
    },
  };
  
  export default theme;